import { createContext, useContext } from 'react';

/**
 * IdleTimeoutContext - lets a screen hold the inactivity countdown open while
 * it runs work the user watches but does not interact with.
 *
 * A long PDF export produces no mouse or key events, so without this the idle
 * timer runs to zero mid-export and signs the user out with their work half
 * done. Consumers must pair every suspend() with a resume() in a finally block.
 *
 * The default value is a pair of no-ops, so a component rendered outside the
 * provider (a test, a storybook) still works.
 */
const noop = () => {};

export const IdleTimeoutContext = createContext({ suspend: noop, resume: noop });

export const useIdleTimeoutControls = () => useContext(IdleTimeoutContext);

export default IdleTimeoutContext;
